import { useDataStore } from "@/stores";
import { FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent } from "@mui/material";
import { useMemo } from "react";

type UseCasesDropdownProps = {
    selectedVersions: string[];
    loading: boolean;
    value: Array<string>;
    onChange: (event: SelectChangeEvent<Array<string>>) => void;
};

const DownloadUseCasesDropdown = ({ selectedVersions, value, loading, onChange }: UseCasesDropdownProps) => {
    const useCases = useDataStore((state) => state.useCases);

    const items = useMemo(() => {
        const commonUseCases = selectedVersions.length
            ? [
                  ...selectedVersions
                      .map((versionId) => useCases[versionId] || [])
                      .reduce((a, b) => a.filter((c) => b.some((d) => d.id === c.id))),
              ]
            : [];
        return commonUseCases;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedVersions, loading]);

    return (
        <FormControl fullWidth size={"medium"} id={"medium"}>
            <InputLabel id="use-cases-dropdown-label">Use-case(s)</InputLabel>
            <Select
                labelId="use-cases-dropdown-label"
                id="use-cases-dropdown"
                value={value}
                onChange={onChange}
                input={<OutlinedInput label={"Use-case(s)"} />}
                MenuProps={{
                    PaperProps: {
                        style: {
                            maxHeight: 48 * 4.5 + 8,
                        },
                    },
                    autoFocus: false,
                }}
                fullWidth
                multiple
            >
                {loading ? (
                    <MenuItem value={""} disabled>
                        Loading...
                    </MenuItem>
                ) : (
                    items
                        .sort((a, b) => a.code.localeCompare(b.code))
                        .map((x) => (
                            <MenuItem key={x.id} value={x.id}>
                                {x.code} {x.name ? `- ${x.name}` : ""}
                            </MenuItem>
                        ))
                )}
            </Select>
        </FormControl>
    );
};

export default DownloadUseCasesDropdown;
